import { createSelector } from 'reselect';

import { dashboardSelector } from 'modules/v2/store/selectors/dashboard';

export const customerPortalLinkSelector = createSelector(
  dashboardSelector,
  (state) => state.customerPortalLink,
);
